import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@mui/material";
import ProductDropdown from "./ProductDropdown";

export interface SkuBaseForecastCreateFormData {
    unitCost: number;
    unitLogs: number;
    recommendedRetailPrice: number;
    distribution: number;
    rateOfSale: number;
    productIds: number[];
}

export interface SkuBaseForecastCreateDialogProps {
    open: boolean;
    loading: boolean;
    formData: SkuBaseForecastCreateFormData;
    productErrorText: string;
    unitCostErrorText: string;
    unitLogsErrorText: string;
    recommendedRetailPriceErrorText: string;
    distributionErrorText: string;
    rateOfSaleErrorText: string;
    existingProductIds: number[];
    onClose: () => void;
    onCreate: (data: SkuBaseForecastCreateFormData) => void;
    onProductsSelected: (productIds: number[]) => void;
    onFormFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onProductsLoaded: (products: any[]) => void;
}

const SkuBaseForecastCreateDialog: React.FC<SkuBaseForecastCreateDialogProps> = ({
    open,
    loading,
    formData,
    productErrorText,
    unitCostErrorText,
    unitLogsErrorText,
    recommendedRetailPriceErrorText,
    distributionErrorText,
    rateOfSaleErrorText,
    existingProductIds,
    onClose,
    onCreate,
    onProductsSelected,
    onFormFieldChange,
    onProductsLoaded
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Create SKU Customer Forecast</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ pb: 2 }}>
                    Enter the details for the new SKU Customer Forecast.
                </DialogContentText>
                <Box sx={{ pb: 2 }}>
                    <ProductDropdown
                        onProductsSelected={onProductsSelected}
                        productErrorText={productErrorText}
                        setProducts={onProductsLoaded}
                        excludedProductIds={existingProductIds}
                    />
                </Box>
                <Box sx={{ pb: 2 }}>
                    <TextField
                        label="Customer Unit Price"
                        name="unitCost"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={formData.unitCost}
                        error={Boolean(unitCostErrorText)}
                        helperText={unitCostErrorText}
                        onChange={onFormFieldChange}
                    />
                </Box>
                <Box sx={{ pb: 2 }}>
                    <TextField
                        label="RRP"
                        name="recommendedRetailPrice"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={formData.recommendedRetailPrice}
                        error={Boolean(recommendedRetailPriceErrorText)}
                        helperText={recommendedRetailPriceErrorText}
                        onChange={onFormFieldChange}
                    />
                </Box>
                <Box sx={{ pb: 2 }}>
                    <TextField
                        label="Distribution"
                        name="distribution"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={formData.distribution}
                        error={Boolean(distributionErrorText)}
                        helperText={distributionErrorText}
                        onChange={onFormFieldChange}
                    />
                </Box>
                <Box sx={{ pb: 2 }}>
                    <TextField
                        label="Rate of Sale"
                        name="rateOfSale"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={formData.rateOfSale}
                        error={Boolean(rateOfSaleErrorText)}
                        helperText={rateOfSaleErrorText}
                        onChange={onFormFieldChange}
                    />
                </Box>
                <Box sx={{ pb: 2 }}>
                    <TextField
                        label="Customer Unit Logs"
                        name="unitLogs"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={formData.unitLogs}
                        error={Boolean(unitLogsErrorText)}
                        helperText={unitLogsErrorText}
                        onChange={onFormFieldChange}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button onClick={() => onCreate(formData)} disabled={loading}>
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SkuBaseForecastCreateDialog;

